import { RootState } from 'store/root-reducer';
import { ExportFolder } from './slice';

export const getExportFolders = (state: RootState): ExportFolder[] | null => state.admin.dumps.folders;

export const isExportFoldersLoading = (state: RootState): boolean => state.admin.dumps.isLoadingFolders;

export const isExportTriggering = (state: RootState): boolean => state.admin.dumps.isTriggering;

export const isExportDeleting = (state: RootState): boolean => state.admin.dumps.isDeleting;

export const isExportDownloading = (state: RootState): boolean => state.admin.dumps.isDownloading;

export const getExportError = (state: RootState): string | null => state.admin.dumps.error;
